import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Tooltip from '@mui/material/Tooltip';
import { useTranslation } from 'react-i18next';

import { setBaseMap } from '../../slices/mapSlice';

export const ChangeBackgroundButton = () => {
  const dispatch = useDispatch();

  const { t } = useTranslation();
  const base = useSelector((state) => state.map.base);
  const openWelcome = useSelector((state) => state.init.open);
  const openModal = useSelector((state) => state.menu.modalOpen);

  const handleChangeBackground = () => {
    if (base === 'osm-tiles') {
      dispatch(setBaseMap('ortho-tiles'));
    } else {
      dispatch(setBaseMap('osm-tiles'));
    }
  };

  const renderImage = () => {
    switch (base) {
      case 'osm-tiles':
        return 'ortho.jpeg';
      case 'ortho-tiles':
        return 'osm_picto.png';
      default:
        return;
    }
  };

  const renderTooltip = () => {
    switch (base) {
      case 'osm-tiles':
        return t('button.ortho_tiles_label');
      case 'ortho-tiles':
        return t('button.osm_tiles_label');
      default:
        return;
    }
  };

  const style = {
    container: {
      display: openWelcome || openModal ? 'none' : 'flex',
      position: 'absolute',
      top: '3rem',
      right: '2.4rem',
      zIndex: 10,
    },
  };

  return (
    <div className='base-button-container' style={style.container}>
      <Tooltip
        slotProps={{
          tooltip: {
            sx: {
              fontSize: '0.8em',
            },
          },
        }}
        title={renderTooltip()}
        placement='left'
      >
        <button className='base-button ' onClick={handleChangeBackground}>
          <img
            src={process.env.PUBLIC_URL + `/image/${renderImage()}`}
            alt='icon'
            className='w-6 h-6'
          />
        </button>
      </Tooltip>
    </div>
  );
};
